import React from 'react'
import SideNav from './SideNav'

const FurnitureDesigns = () => {
  return (
    <div>
      <>
        <div className="page-header-furniture-designs parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Furniture Designs
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">
                      About Us
                    </a>
                    <a href="contact-us" className="btn-default btn-highlighted">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">
                  <div className="service-feature-image">
                    <figure className="image-anime reveal">
                      <img src="/imgs/furniture-design.jpg" alt="Furniture Designs" />
                    </figure>
                  </div>

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      At <b>MeHome</b>, we design furniture that reflects your lifestyle and enhances your comfort.
                      Our <b>custom furniture solutions</b> combine modern design, functionality, and high-quality
                      materials to create elegant, durable, and space-optimized interiors.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Blending <span>Style, Comfort & Craftsmanship</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      Whether it’s for your living room, bedroom, or workspace, our furniture designs
                      bring sophistication and utility together. Every piece is crafted to complement
                      your interiors while offering maximum comfort and longevity.
                    </p>

                    <ul>
                      <li>Custom-designed furniture for every space and style.</li>
                      <li>Modular and multifunctional units for compact homes.</li>
                      <li>Luxury materials, fabrics, and finishes of global standards.</li>
                      <li>Smart space-saving storage and ergonomic designs.</li>
                      <li>Complete end-to-end production and installation.</li>
                    </ul>
                  </div>

                  <div className="why-choose-content service-single-why-choose">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Specialized <span> Furniture Solutions</span>
                      </h2>
                    </div>

                    <div className="why-choose-item-list">
                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.4s">
                        <div className="icon-box">🛋️</div>
                        <div className="why-choose-item-content">
                          <h3>Living Room Furniture</h3>
                          <p>
                            Sofas, TV units, and center tables designed for beauty and comfort.
                            We create living spaces that feel luxurious and welcoming.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.6s">
                        <div className="icon-box">🛏️</div>
                        <div className="why-choose-item-content">
                          <h3>Bedroom Furniture</h3>
                          <p>
                            Elegant beds, wardrobes, and dressing units customized for comfort,
                            durability, and storage efficiency.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="0.8s">
                        <div className="icon-box">🍽️</div>
                        <div className="why-choose-item-content">
                          <h3>Dining & Kitchen Furniture</h3>
                          <p>
                            Modular dining tables, cabinets, and kitchen designs that make
                            everyday living stylish and organized.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1s">
                        <div className="icon-box">💼</div>
                        <div className="why-choose-item-content">
                          <h3>Office & Workspace Furniture</h3>
                          <p>
                            Ergonomic workstations and smart office setups that enhance productivity
                            while maintaining aesthetic appeal.
                          </p>
                        </div>
                      </div>

                      <div className="why-choose-item wow fadeInUp" data-wow-delay="1.2s">
                        <div className="icon-box">🪵</div>
                        <div className="why-choose-item-content">
                          <h3>Custom Built Furniture</h3>
                          <p>
                            Unique furniture designs crafted to your vision — blending materials,
                            finishes, and dimensions for a perfect fit.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="service-gallery wow fadeInUp" data-wow-delay="0.6s">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Our Recent <span> Furniture Projects</span>
                      </h2>
                    </div>
                    <div className="row g-3">
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/furniture1.jpg" alt="Furniture Project 1" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/furniture2.jpg" alt="Furniture Project 2" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <img src="/images/furniture3.jpg" alt="Furniture Project 3" className="img-fluid rounded-3 shadow-sm" />
                      </div>
                    </div>
                  </div>

                  <div className="service-single-faq">
                    <div className="section-title">
                      <h2 className="text-anime-style-2" data-cursor="-opaque">
                        Why Choose <span> MeHome for Furniture Designs</span>
                      </h2>
                    </div>
                    <div className="wow fadeInUp" data-wow-delay="0.6s">
                      <ul>
                        <li><b>6+ Years of Expertise</b> in interior and furniture design.</li>
                        <li><b>Custom-Tailored Solutions</b> built for your lifestyle and needs.</li>
                        <li><b>Premium Material Selection</b> with lasting durability.</li>
                        <li><b>Affordable Luxury</b> — premium results within your budget.</li>
                        <li><b>On-Time Project Delivery</b> with hassle-free installation.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default FurnitureDesigns
